import { render, staticRenderFns } from "./SpuList.vue?vue&type=template&id=1894d7de"
import script from "./SpuList.vue?vue&type=script&lang=ts"
export * from "./SpuList.vue?vue&type=script&lang=ts"
import style0 from "./SpuList.vue?vue&type=style&index=0&id=1894d7de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports